import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Wrench } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/leuteliaApi";

export default function SoluzioniInterruttore({ tenants = [], hotels = [] }) {
  const [f, setF] = useState(null);
  const load = () => api.soluzioniFeature().then(setF).catch((e) => toast.error(e.message));
  useEffect(() => { load(); }, []);
  if (!f) return null;
  const effective = (t) => !f.disabled_tenants.includes(t) && (f.enabled || f.tenants.includes(t));
  const set = async (body, msg) => { try { setF(await api.soluzioniFeatureSet(body)); toast.success(msg); window.dispatchEvent(new Event("leutelia:soluzioni-feature")); } catch (e) { toast.error(e.message); } };
  return (
    <div className="bg-white rounded-xl border border-brand-gold/25 p-5" data-testid="admin-soluzioni">
      <div className="flex items-center gap-2 mb-1"><Wrench size={18} className="text-brand-gold" /><h3 className="font-serif text-[20px] text-brand-ink">Soluzioni Pratiche</h3></div>
      <p className="text-[12px] text-brand-muted mb-3">Problema → soluzione → quanto recuperi. Parte integrante di LEUTELIA per tutti gli hotel (nessun costo in più, nessuna nuova analisi). Qui puoi spegnerla o accenderla hotel per hotel.</p>
      <label className="flex items-center justify-between gap-3 rounded-lg border border-brand-gold/20 bg-brand-cream/40 px-3 py-2 text-[13px] font-semibold text-brand-ink">Accesa per tutti gli hotel
        <Switch checked={!!f.enabled} onCheckedChange={(v) => set({ enabled: v }, v ? "Soluzioni Pratiche accesa per tutti." : "Soluzioni Pratiche spenta per tutti (restano accesi solo gli hotel attivati singolarmente).")} data-testid="admin-soluzioni-global" />
      </label>
      <div className="mt-3 space-y-1.5">
        {tenants.map((t) => (
          <label key={t} className="flex items-center justify-between gap-3 px-3 py-1.5 text-[12.5px] text-brand-ink" data-testid={`admin-soluzioni-row-${t}`}>
            <span>{hotels.filter((h) => h.tenant === t).map((h) => h.name || h.hotel).join(", ") || t} <span className="text-brand-muted">· {t}</span></span>
            <Switch checked={effective(t)} onCheckedChange={(v) => set({ tenant: t, on: v }, `${v ? "Accesa" : "Spenta"} per ${t}.`)} data-testid={`admin-soluzioni-${t}`} />
          </label>
        ))}
      </div>
      {f.updated_at && <p className="text-[11px] text-brand-muted mt-2">Ultima modifica: {new Date(f.updated_at).toLocaleString("it-IT")} · {f.updated_by}</p>}
    </div>
  );
}
